import { render, staticRenderFns } from "./HealthOptions.vue?vue&type=template&id=48635c14"
import script from "./HealthOptions.vue?vue&type=script&lang=js"
export * from "./HealthOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports